import React, { useEffect } from 'react';
import auth from '../../services/authService';

export default function Logout(props) {
  useEffect(() => {
    auth.logout();

    window.location = '/';
  }, []);

  return null;
}
